export const convertNewlineToSapLinebreaks = (string: string): string => {
    const convertedContent = string.replace(/(\r\n|\n|\r)/gm, '\\n');

    return convertedContent;
};
